import   React               ,
       { useState            ,
         useEffect            }  from "react";

import   classNames             from "classnames";

import   styles                 from "./Cart.module.scss";

import   Window                 from "../../widget/windows/window";
import   AnimatedWaitingIcon2   from "../../widget/animations/animatedWaitingIcon2";

import   BankChoice             from "./BankChoice";

import { createPayment        }  from "../../../backendServices/purchaseManagment/api";

import { openPaymentPopup     ,
         redirectPaymentPopup ,
         listenForPaymentResult ,
         PaymentResultStatus   }  from "../../../utils/utils_paymentPopup";
import { pollAdminRefreshAfterPurchase }  from "../../../utils/utils_pollAdminRefresh";

import { useTypedSelector     ,
         useTypedDispatch      }  from "../../../store/useTypeSelector";
import { closePurchaseModal   }  from "../../../store/purchaseModalManagment/actions";

// Monté une seule fois, à la racine de l'app (index.tsx) : point d'arrivée commun
// de tous les boutons « Acheter » de quota (disque, devices, chaînes, durées — cf.
// utils_*Purchase.ts). Ceux-ci ajoutent l'article au panier du créateur PUIS ouvrent
// directement cette fenêtre (openPurchaseModal) — l'utilisateur ne voit jamais
// l'onglet Achats ni le panier lui-même, seulement le choix du moyen de paiement.
//
// La banque s'ouvre dans une fenêtre À PART (utils_paymentPopup.ts) plutôt que de
// rediriger cet onglet : PayPal/Stripe ne savent rediriger que le navigateur lui-même,
// et le faire ici rechargeait toute la SPA au retour — perte de la session Redux, donc
// reconnexion imposée pour un simple achat de quota (signalé par Alex, 2026-09-14). Cet
// onglet ne bouge plus jamais ; le résultat arrive par message (payment_success.tsx /
// payment_failure.tsx dans la fenêtre à part) et s'affiche ICI, sans navigation.
export const QuotaPurchaseModal: React.FC = () => {

  const dispatch = useTypedDispatch();

  const { open, cartId, amount, label } = useTypedSelector((state) => state.purchaseModalReducer);
  const email = useTypedSelector((state) => state.authenticationReducer.authentication.admin?.email);

  const [ paying , setPaying ] = useState(false);
  const [ error  , setError  ] = useState('');
  const [ result , setResult ] = useState<PaymentResultStatus | null>(null);

  useEffect(() => {
    if (!open) return;

    return listenForPaymentResult((status) => {
      setPaying(false);
      setResult(status);

      // Le quota n'est crédité qu'au webhook PayPal/Stripe, pas à l'instant où l'onglet
      // de paiement se referme : un seul refreshAdmin() ici lirait encore souvent
      // l'ancien quota dans le header. Cf. utils_pollAdminRefresh.ts.
      if (status === 'success' && email) {
        pollAdminRefreshAfterPurchase(email);
      }
    });
  }, [open, email]);

  if (!open || cartId === null) {
    return null;
  }

  const close = () => {
    setError('');
    setResult(null);
    dispatch(closePurchaseModal());
  };

  const handlePay = async (bankCode: string) => {
    if (!email) {
      setError("Impossible d'identifier le compte créateur.");
      return;
    }

    // Doit être appelé de façon SYNCHRONE (avant le await ci-dessous) : au-delà du
    // gestionnaire de clic direct, le navigateur bloque window.open().
    const popup = openPaymentPopup();

    if (!popup) {
      setError("Le navigateur a bloqué la fenêtre de paiement. Autorisez les popups pour ce site puis réessayez.");
      return;
    }

    setPaying(true);
    setError('');

    const response = await createPayment(amount, cartId, bankCode, email, label);

    if (response.code === 1) {
      redirectPaymentPopup(popup, response.payload);
    } else {
      popup.close();
      setError(response.comment || "Impossible de créer le paiement.");
      setPaying(false);
    }
  };

  if (result) {
    return (
      <Window
        message={<>{result === 'success' ? "Paiement confirmé. Merci, votre achat a bien été enregistré." : "Le paiement n'a pas abouti. Le panier n'a pas été modifié."}</>}
        messageType="information"
        onClickOnValidateButton={close}
        validButtonText="Fermer"
        zIndex={9995}
      />
    );
  }

  if (error) {
    return (
      <Window
        message={<>{error}</>}
        messageType="information"
        onClickOnValidateButton={close}
        validButtonText="Fermer"
        zIndex={9995}
      />
    );
  }

  return (
    <>
      <BankChoice onCancel={close} onValidate={handlePay} />

      {paying && (
        <div className={classNames(styles.overlay)}>
          <AnimatedWaitingIcon2 />
        </div>
      )}
    </>
  );
};

export default QuotaPurchaseModal;
